// extracted by mini-css-extract-plugin
export var dropdown = "_u0-0";
export var imageWrapper = "_u0-3";
export var itemNameContainer = "_u0-1";
export var productImage = "_u0-2";
export var spinnerWrapper = "_u0-4";